import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import TravelInsuranceSuccessWrapper from "./style";
import billPaid from "../../../../assets/images/billPaid.svg";
import worldcup from "../../../../assets/images/worldcup_orange.svg";
import privecyDownloadTravel from "../../../../assets/images/icons/privecy-download-travel.svg";
import * as paymentServices from "../../../../services/payment-service";
import { setLoading } from "../../../../redux/actions/travel";
import { generateSha256Hash } from "../../../../helpers/utils";
import * as globalUtils from "../../../../helpers/utils";

const TravelInsuranceSuccess = (props) => {
  const { t, i18n } = props;
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [policyNumber, setPolicyNumber] = useState(
    location.state ? location.state.policyNumber : ""
  );

  const [BillNumber, setBillNumber] = useState(
    location.state ? location.state.billNo : ""
  );

  const [paymentData, setPaymentData] = useState(null);
  const { isWorldcup } = useSelector((state) => state.travel);
  const { travelGoogleTaggingData } = useSelector((state) => state.travel);
  const checkoutId = window.localStorage.getItem("travelCheckoutId");

  // useEffect(() => {
  //   if (checkoutId) {
  //     let productName = localStorage.getItem("productName");
  //     let subProductName = localStorage.getItem("subProductName");
  //     dispatch(setLoading(true));
  //     paymentServices
  //       .getPaymentById({ id: checkoutId })
  //       .then((response) => {
  //         const data = response.data;
  //         if (data.resultCode === "S") {
  //           if (productName !== "" || subProductName !== "") {
  //             window.lmSMTObj.track("purchaseCompleted", {
  //               "paymentSuccessful": "true",
  //               "productName": productName,
  //               "subProductName": subProductName
  //             })
  //           }
  //           setPolicyNumber(data.policyNo);
  //           dispatch(setLoading(false));
  //           const localData = JSON.parse(window.localStorage.getItem("travelCreditcardPaymentData"));
  //           forGoogleTagging(localData, data.policyNo);
  //           setPaymentData(localData);
  //           // clean up local storage
  //           window.localStorage.removeItem("travelCheckoutId");
  //           window.localStorage.removeItem("travelCreditcardPaymentData");
  //         } else {
  //           if (productName !== "" || subProductName !== "") {
  //             window.lmSMTObj.track("purchaseCompleted", {
  //               "paymentSuccessful": "false",
  //               "productName": productName,
  //               "subProductName": subProductName
  //             })
  //           }
  //           navigate("/travel/failed", { replace: true });
  //         }

  //         // setAmount(data.getPaymentDetailsByIdResponse.amount);
  //         // setPaymentType("Credit Card")
  //       })
  //       .catch((err) => {
  //         if (productName !== "" || subProductName !== "") {
  //           window.lmSMTObj.track("purchaseCompleted", {
  //             "paymentSuccessful": "false",
  //             "productName": productName,
  //             "subProductName": subProductName
  //           })
  //         }
  //         dispatch(setLoading(false));
  //         navigate("/travel/failed", { replace: true });
  //       });
  //   }
  // }, [checkoutId]);

  useEffect(() => {
    let productName = localStorage.getItem("productName");
    let subProductName = localStorage.getItem("subProductName");
    if (productName !== "" || subProductName !== "") {
      // window.lmSMTObj.page(location.pathname, {
      //   path: location.pathname,
      //   language: globalUtils.isArabic(i18n.language) ? "Arabic" : "English",
      //   referrer: document.referrer,
      //   title: document.title,
      //   url: document.URL,
      //   search: "",
      // });
      window.lmSMTObj.track("purchaseCompleted", {
        paymentSuccessful: "false",
        productName: productName,
        subProductName: subProductName,
      });
    }
  }, []);

  useEffect(() => {
    if (Boolean(Object.keys(travelGoogleTaggingData).length)) {
      setPaymentData(travelGoogleTaggingData);
      // forGoogleTagging(travelGoogleTaggingData);
    }
  }, [travelGoogleTaggingData]);

  // for Google tagging (after success payment)

  useEffect(() => {
    forGoogleTagging();
  }, []);

  const forGoogleTagging = async (data, policyNum = "") => {
    const hashedEmail = await generateSha256Hash(data.email);
    const hashedPhone = await generateSha256Hash(data.phone);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "travel_new_purchased_v2",
      item_name: "Travel Insurance New",
      item_category: "Travel Insurance",
      item_class: "Individual",
      funnel_step: "step_8",
      travelling_to: data?.travelling_to,
      travelling_with_family: data?.travelling_with_family,
      travelling_with_friends: data?.travelling_with_family,
      num_travellers: parseFloat(data?.num_travellers),
      num_days: parseFloat(data?.num_days),
      fursan_membership: data?.fursan_mempership || "No",
      sha_256_email: hashedEmail,
      sha_256_phone: hashedPhone,
      policy_id: BillNumber || BillNumber,
      items: [
        {
          name: data?.itemName,
          id: data?.travelling_to_id,
          price: parseFloat(data?.itemPrice),
        },
      ],
      ecommerce: {
        transaction_id:
          data?.selected_payment_method === "Sadad" ? BillNumber : BillNumber,
        value: parseFloat(data?.itemPrice),
        tax: parseFloat(data?.tax),
        shipping: 0.0,
        currency: "SAR",
        coupon: data?.coupon || "",
        payment_method: data?.selected_payment_method,
        items: [
          {
            item_id: data?.travelling_to_sub_id,
            item_name: data?.travelling_to,
            item_category: "Travel Insurance",
            item_category2: "Travel Insurance New",
            item_variant: data?.itemName,
            price: parseFloat(data?.itemPrice),
            quantity: 1,
          },
        ],
      },
    });
  };

  return (
    <TravelInsuranceSuccessWrapper>
      <div className="container-fluid">
        <div
          className={`${
            isWorldcup || paymentData?.isWorldcup
              ? "worldcup_success_wrapper"
              : ""
          }`}
        >
          {(isWorldcup || paymentData?.isWorldcup) && (
            <div className="worldcup_banner">
              <img src={worldcup} />
              <div>
                <h5>{t("worldcup.worldcup")}</h5>
                <p>{t("worldcup.date")}</p>
              </div>
            </div>
          )}
          <div className="elementWrapper">
            {/* {isWorldcup && <h6 className="worldcup_sadad_payment_info">{t("worldcup.payment_caution")}</h6>} */}
            <div className="iconStyle">
              <img alt="" src={billPaid} />
            </div>
            {paymentData?.selected_payment_method === "Credit Card" ? (
              <>
                <h1 className="textStyle">{t("worldcup.thank_you")}</h1>
                {(isWorldcup || paymentData?.isWorldcup) && (
                  <h1 className="textStyle">{t("worldcup.enjoy_wc")}</h1>
                )}
              </>
            ) : (
              <>
                <h1 className="textStyle">{t("worldcup.travel_quotation")}</h1>
                <h1 className="textStyle">
                  {t("worldcup.submit_sadad")} #{policyNumber}
                </h1>
                <h6 className="worldcup_sadad_payment_info">
                  {t("worldcup.payment_caution")}
                </h6>
              </>
            )}
            {/* <h4 className="messageStyle">{t("ready-to-use")}</h4> */}
            {/* <Button className="buttonStyle">
            <img className="imgStyle" src={pdfDownload} />
            <h3 className="labelStyle">{t('download-policy')}</h3>
          </Button> */}
            {/* <a href="https://tawuniya.com.sa" className="backLinkStyle">
       <h3 className="backTextStyle">{t("back-to-tawuniya-homepage")}</h3>
      </a> */}
            <a
              rel="noreferrer"
              className="download-link"
              href="https://www.tawuniya.com/docs/Travel_and_Covid_Policy_Wordings_new_brand_09-04-2023.pdf"
              target="_blank"
            >
              <div className="download">
                <img src={privecyDownloadTravel} alt="Download Icon" />
                <div className="policy-download">
                  <h6 className="policy-download-title">
                    {t("worldcup.policy_download_title")}
                  </h6>
                  <p className="policy-download-description">
                    {t("worldcup.policy_download_description")}
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <img src="https://disruptive.gotrackier.com/pixel?adid=65d30fe0be930e78dc70ea33" />
    </TravelInsuranceSuccessWrapper>
  );
};
export default withTranslation()(TravelInsuranceSuccess);
